 /* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// utils
// styles
import injectSheet from "react-jss";
import styles from './previewconfig_styles.js';


/* ========== ~~~~~~~~~~ COMMENTING: PREVIEW CONFIG ~~~~~~~~~~ ========== */
const PreviewConfig = injectSheet(styles)((props) => {
  const { title, children, disabled } = props
  return (
    <div className={`previewconfig ${props.classes.previewconfig} ${props.klass} disabled-${!!disabled}`}>
      <div className='header'>{title || 'Preview'}</div>
      <div className={'content'}>{children}</div>
    </div>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default PreviewConfig